import { useEffect } from 'react';
import { useNotificationStore } from '../store';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Bell, Loader2 } from 'lucide-react';

const formatDate = (date) => new Date(date).toLocaleDateString('en-NG', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });

export default function NotificationsPage() {
  const { notifications, fetchNotifications, markAsRead } = useNotificationStore();

  useEffect(() => { fetchNotifications(); }, [fetchNotifications]);

  const handleClick = (notification) => { if (!notification.read) markAsRead(notification.id); };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white font-['Outfit']">Notifications</h1>
      {notifications.length === 0 ? (
        <div className="text-center py-12"><Bell className="w-16 h-16 mx-auto text-zinc-600 mb-4" /><p className="text-zinc-400">No notifications</p></div>
      ) : (
        <div className="space-y-4">
          {notifications.map((notification) => (
            <Card key={notification.id} className={`bg-[#0A0A0A] border-white/10 cursor-pointer transition-colors ${!notification.read ? 'border-l-4 border-l-[#FFD700]' : ''}`} onClick={() => handleClick(notification)}>
              <CardContent className="p-4">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="font-semibold text-white">{notification.title}</h3>
                    <p className="text-zinc-400 mt-1">{notification.content}</p>
                    <p className="text-xs text-zinc-500 mt-2">{formatDate(notification.created_at)}</p>
                  </div>
                  {!notification.read && <Badge className="bg-[#FFD700] text-black">New</Badge>}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
